<template>
  <v-tooltip
    :top="position === 'top'"
    :bottom="position === 'bottom'"
    :left="position === 'left'"
    :right="position === 'right'"
  >
    <template v-slot:activator="{ on, attrs }">
      <span v-on="on" v-bind="attrs" class="d-inline-flex">
        <Icon :class="iconClass" :color="color" icon="mdi-help-circle" />
      </span>
    </template>
    <slot />
  </v-tooltip>
</template>

<script>
import Icon from "@/components/generic/Icon.vue";
export default {
  name: "HelpTooltip",
  components: {
    Icon,
  },
  props: {
    position: {
      type: String,
      default: "top",
      validator: (v) => ["top", "bottom", "left", "right"].includes(v),
    },
    color: {
      type: String,
      default: "gray",
    },
    iconClass: {
      type: String,
      default: "",
    },
  },
};
</script>

<style>
.v-tooltip__content {
  opacity: 1 !important;
}
</style>
